import { createColDef } from '@fortem-monorepo/react-ag'

import { BarrierTypeCellEditor } from '@/ag-grid/columns/barrier-type/cell-editor'
import { BarrierTypeCellRenderer } from '@/ag-grid/columns/barrier-type/renderer'

export const barrier_type = createColDef<any>({
  field: 'barrier_type',
  headerName: 'Barrier Type',
  cellRenderer: BarrierTypeCellRenderer,
  cellEditor: BarrierTypeCellEditor,
  width: 150,
})
